<template>
    <div>
        <modal class="booking-choose-contract-version" :display="modalStatus.bizBookingContractVersion" @modalStatus="closeModal" >
            <h1>確認合約版本</h1>
            <div class="booking-choose-contract-version-wrap" :key="'height'+componentKey">
                <div class="content">
                    <div class="description">
                        提醒您：預設合約為您在飛豬找房上公告的合約，如您選擇另一份合約，房客要求退訂時您將不會收到退訂金額。
                    </div>
                    <div class="sub-title" v-if="currentContractVersionId">
                        目前合約版本
                    </div>
                    <div class="list" v-if="currentContractVersionId">
                        <div class="item h-align">
                            <div class="radio-group h-align" :class="{'active': selectedContract === contractVersionList[currentVersionIndex].id}">
                                <radio v-model="selectedContract" :val="contractVersionList[currentVersionIndex].id" :isPropChecked="selectedContract === contractVersionList[currentVersionIndex].id"></radio>
                                <img class="type-icon" v-if="contractVersionList[currentVersionIndex].contractMode === 'CHARTER'" src="@/assets/img/component/contractVersion/charter.svg" alt="">
                                <img class="type-icon" v-else-if="contractVersionList[currentVersionIndex].contractMode === 'ESCROW'" src="@/assets/img/component/contractVersion/escrow.svg" alt="">
                                <div class="type-text" :class="{'charter': contractVersionList[currentVersionIndex].contractMode === 'CHARTER', 'escrow': contractVersionList[currentVersionIndex].contractMode === 'ESCROW'}">{{contractVersionList[currentVersionIndex].contractMode === 'CHARTER'?'包租':'代管'}}</div>
                                <div class="version-name">{{contractVersionList[currentVersionIndex].name}}</div>
                            </div>
                            <div class="preview" @click="previewContractVersion(contractVersionList[currentVersionIndex].id)">預覽</div>
                        </div>
                    </div>
                    <div class="sub-title">
                        其他版本合約
                    </div>
                    <div class="list">
                        <div class="item h-align" v-for="(item, index) in filterDuplicate" :key="index">
                            <div class="radio-group h-align" :class="{'active': selectedContract === item.id}">
                                <radio v-model="selectedContract" :val="item.id" :isPropChecked="selectedContract === item.id"></radio>
                                <img class="type-icon" v-if="item.contractMode === 'CHARTER'" src="@/assets/img/component/contractVersion/charter.svg" alt="">
                                <img class="type-icon" v-else-if="item.contractMode === 'ESCROW'" src="@/assets/img/component/contractVersion/escrow.svg" alt="">
                                <div class="type-text" :class="{'charter': item.contractMode === 'CHARTER', 'escrow': item.contractMode === 'ESCROW'}">{{item.contractMode === 'CHARTER'?'包租':'代管'}}</div>
                                <div class="version-name">{{item.name}}</div>
                            </div>
                            <div class="preview" @click="previewContractVersion(item.id)">預覽</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="signContract()">產生合約</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import radio from '@/components/bussiness/widges/input/radio.vue';
import { 
    getContractVersionList,
    getHouseContractVersion
    } from "@/apis/company/contractVersion.js"; 
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            contractVersionList: [],
            currentContractVersionId: null,
            selectedContract: null,
            componentKey: 0,
        }
    },
    props: {
        bookingContractIds: null
    },
    created (){
        this.getContractVersionList()
    },
    mounted (){
    },
    destroyed() {
    },
    watch: {
        'bookingContractIds.bookingSelectedHouseId': function (val) {
            if(val){
                this.getHouseContractVersion(val)
            }
        }
    },
    methods: {
        getContractVersionList: function () {
            // console.log('取得合約版本列表')
            getContractVersionList()
            .then( res => {
                if(res.data.status === 'SUCCESS'){
                    this.contractVersionList = res.data.result
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getHouseContractVersion: function (id) {
            const params = {
                houseCid: id
            }
            getHouseContractVersion(params)
            .then( res => {
                console.log(res)
                if(res.data.status === 'SUCCESS'){
                    this.currentContractVersionId = res.data.result.contractVersionId
                    this.selectedContract = res.data.result.contractVersionId
                    // this.contractVersionList = res.data.result
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        previewContractVersion: function (id) {
            let routeData = this.$router.resolve({name:'contractPaper',query:{cid:id, mode: 'version'}});
            window.open(routeData.href, '_blank');
        },
        signContract: function () {
            let route = this.$router.resolve({name: 'bizContractDefault', query: {'contractCid': this.bookingContractIds.contractId, 'contractVersionId': this.selectedContract , 'mode': 'contract'}})
            window.open(route.href, '_blank');
            this.closeModal()
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizBookingContractVersion'})
        },
    },
    computed: {
        currentVersionIndex: function () {
            const list = this.contractVersionList
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.id === this.currentContractVersionId){
                    return i
                }                
            }
        },
        filterDuplicate: function () {
            return this.contractVersionList.filter((item) => {
                if(this.currentContractVersionId){
                    if(item.id !== this.currentContractVersionId ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        // checked: {
        //     get () {
        //         return this.value
        //     },
        //     set (val) {
        //         this.checkVal = val
        //         this.$emit('input', val)
        //     }
        // },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        radio
    }
}
</script>
<style lang="scss">
    #modal.booking-choose-contract-version{
        .modal-content{
            width: 780px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 20px;
                }
                .alarm-msg{
                    top: 10px;
                }
                .booking-choose-contract-version-wrap{
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0 32px 32px 32px;
                    max-height: 415px;
                    overflow-x: hidden;
                    .content{
                        .description{
                            color: #676362;
                            margin-bottom: 24px;
                        }
                        .sub-title{
                            font-size: 16px;
                            font-weight: 500;
                            color: #ff9275;
                            margin-bottom: 16px;
                        }
                        .list{
                            .item{
                                margin-bottom: 16px;
                                .radio-group {
                                    width: 650px;
                                    border-radius: 6px;
                                    border: solid 1px #f3f3f3;
                                    background-color: #ffffff;
                                    padding: 0 16px;
                                    box-sizing: border-box;
                                    margin-right: 16px;
                                    height: 56px;
                                    &.active{
                                        border: solid 1px #ff9275;
                                    }
                                    .radio{
                                        margin-right: 8px;
                                    }
                                    .type-icon{
                                    width: 24px; 
                                    margin-right: 2px;
                                    }
                                    .type-text{
                                        position: relative;
                                        margin-right: 25px;
                                        &::after{
                                            content: '';
                                            position: absolute;
                                            width: 1px;
                                            height: 16px;
                                            background: #e1e1e1;
                                            right: -12px;
                                        }
                                        &.charter{
                                            color: #3942b5;
                                        }
                                        &.escrow{
                                            color: #fcb773;
                                        }
                                    }
                                    .version-name{
                                        font-size: 16px;
                                        font-weight: 500;
                                    }
                                }
                                .preview{
                                    color: #ff9275;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.reject{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/leaseProcess/chooseContractVersion.vue